export default __webpack_public_path__ + "static/media/BROCHURE-2021.cee9bcbf.pdf";